const defaultImages = [
  // require("../images/hiring1.jpg"),
  // require("../images/hiring2.jpg"),
  // require("../images/hiring3.jpg"),
  // require("../images/hiring4.jpg"),
  // require("../images/hiring5.jpg"),
  // require("../images/hiring6.jpg"),
  require("../images/sample6.jpg"),
  require("../images/sample.jpg"),
  require("../images/sample7.jpg"),
  require("../images/sample3.jpg"),
  require("../images/sample5.jpg"),
  require("../images/sample2.jpg"),
];

export default defaultImages;